/**
 * MUI X Charts inspired color palette - vibrant and accessible
 * Uses a diverse palette optimized for data visualization
 * @type {string[]}
 */
export const CHART_COLORS = [
  "#02B2AF", // teal (MUI X primary)
  "#2E96FF", // blue
  "#B800D8", // purple
  "#60009B", // dark purple
  "#2731C8", // indigo
  "#03008D", // navy
  "#FF6B6B", // coral red
  "#4ECDC4", // mint
  "#45B7D1", // sky blue
  "#96CEB4", // sage green
  "#E67E22", // burnt orange
  "#DDA0DD", // plum
  "#98D8C8", // seafoam
  "#6B8E23", // olive green
  "#BB8FCE", // lavender
  "#85C1E9", // light blue
  "#D35400", // dark orange
  "#00CED1", // dark cyan
  "#FF7F50", // coral
  "#9B59B6", // amethyst
];

/**
 * Generate distinct colors for the chart based on count
 * @param {number} count - Number of colors to generate
 * @returns {string[]} Array of color hex strings
 */
export function generateChartColors(count) {
  const colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(CHART_COLORS[i % CHART_COLORS.length]);
  }
  return colors;
}

/**
 * Get a single color by index, cycling through the palette
 * @param {number} index - Index of the color
 * @returns {string} Color hex string
 */
export function getChartColor(index) {
  return CHART_COLORS[index % CHART_COLORS.length];
}
